export const MY_SESSIONS_GROUP_REQUEST = 'mySessionsGroupReducer/MY_SESSIONS_GROUP_REQUEST';
export const MY_SESSIONS_GROUP_SUCCESS = 'mySessionsGroupReducer/MY_SESSIONS_GROUP_SUCCESS';
export const MY_SESSIONS_GROUP_FAILED = 'mySessionsGroupReducer/MY_SESSIONS_GROUP_FAILED';